'use client'

import { useUserContext } from '@/context'
import { useOrganizationMembers } from '@/services/queries/team'

export function useSelectedTeamMembers(teamId?: string | null) {
  const { organizationScope } = useUserContext()
  const resolvedTeamId =
    teamId === null
      ? undefined
      : (teamId ?? organizationScope.selectedOrganizationId ?? undefined)

  return useOrganizationMembers(resolvedTeamId)
}
